var _path, _path2, _linearGradient, _path3, _path4, _path5, _path6, _path7, _linearGradient2, _path8, _linearGradient3, _path9, _linearGradient4, _path10, _linearGradient5, _path11, _linearGradient6, _path12, _linearGradient7, _path13, _linearGradient8, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "7.086 7.087 1277.149 924.008"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1138.734 931.095h.283m0 0h-.283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.439 7.087c57.543 0 104.627 47.083 104.627 104.626v30.331l-145.36 103.833-494.873 340.894L148.96 242.419v688.676h-37.247c-57.543 0-104.627-47.082-104.627-104.625V111.742C7.086 54.198 54.17 7.115 111.713 7.115l532.12 394.525L1179.41 7.115l.029-.028z",
    fill: "#e75a4d"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__a)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e4d7",
    d: "M148.96 242.419v688.676h989.774V245.877L643.833 586.771z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8b7ae",
    d: "M148.96 931.095l494.873-344.324-2.24-1.586L148.96 923.527z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7b6ad",
    d: "M1138.734 245.877l.283 685.218-495.184-344.324z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.066 142.044l.17 684.51c-2.494 76.082-35.461 103.238-145.219 104.514l-.283-685.219 145.36-103.833-.028.028z",
    fill: "#b2392f"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__b)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__c)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__d)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__e)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__f)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__g)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gmail_svg__h)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f5ed",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgGmail as ReactComponent };